<p-dialog
  [visible]="visible"
  [modal]="true"
  [style]="{ width: '25rem' }"
  [closable]="false"
>
  <ng-template #header> Select a file to upload: </ng-template>
  <div class="card flex justify-center mb-0">
    {{ fileName }}
    <div class="flex flex-col items-center gap-4">
      <p-fileupload
        #fileUpload
        *ngIf="!isLoading"
        mode="basic"
        name="demo[]"
        chooseIcon="pi pi-upload"
        url="https://www.primefaces.org/cdn/api/upload.php"
        accept=".csv,.txt,.xlsx,.xlsm,.xls,.xlsb,text/plain,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/vnd.ms-excel.sheet.binary.macroEnabled.12"
        [customUpload]="true"
        (uploadHandler)="onFileSelect($event)"
        [auto]="true"
        chooseLabel="Browse"
      />
      <p-progress-spinner
        *ngIf="isLoading"
        strokeWidth="8"
        fill="transparent"
        animationDuration=".5s"
        [style]="{ width: '50px', height: '50px' }"
      />

      <div class="flex flex-row gap-4 mt-4" *ngIf="!isLoading && !fileExists">
        <p>Country:</p>

        <p-listbox
          *ngIf="!isLoading && !fileExists"
          [options]="countries"
          [(ngModel)]="selectedCountry"
          optionLabel="name"
          class="w-full md:w-56"
        >
          <ng-template #item let-country>
            <div class="flex items-center gap-2">
              <img
                src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                [class]="'flag flag-' + country.code.toLowerCase()"
                style="width: 18px"
              />
              <div>{{ country.name }}</div>
            </div>
          </ng-template>
        </p-listbox>
      </div>
    </div>

    <p-toast />
    <p-confirmpopup />
  </div>

  <ng-template #footer>
    <p-button
      label="Cancel"
      [outlined]="true"
      severity="secondary"
      (onClick)="handleCloseDialog()"
    />
  </ng-template>
</p-dialog>
